import * as React from 'react';
import { setupCookies } from '../scripts/cookies';
import cookies from '../templates/cookies.pug';
import template from '../templates/footer.pug';
import { Pug } from './Pug';

export class GlobalFooter extends React.Component {
    componentDidMount(): void {
        setupCookies();
    }

    render() {
        return (
            <footer>
                <Pug template={template} />
                <Pug template={cookies} />
            </footer>
        );
    }
}
